import { openModal } from '@core/components/ModalStack';
import { SendInvoiceModalProps } from './SendInvoiceModal';

export async function openSendInvoiceModal(props: SendInvoiceModalProps) {
  const { SendInvoiceModal } = await import('./SendInvoiceModal');

  openModal(SendInvoiceModal, props);
}
